// extracted by extract-css-chunks-webpack-plugin
module.exports = {"sized":"_2ulGk","textAligned":"ymgDF"};